import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type { Model } from 'frontend-payments/routes/authenticated/payment-method';

export default class AuthenticatedPaymentMethodController extends Controller {
  declare model: Model;

  @service declare router: Services['router'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get account() {
    if (this.isAccountRequestLoading || !this.model) {
      return null;
    }
    return this.model.account?.value;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isAccountRequestLoading() {
    return this.model?.account?.isRunning ?? false;
  }

  @action
  onBack(): void {
    this.router.transitionTo('authenticated.overview');
  }
}
